import React from 'react';
import Input from '../RegularInput';
import { InputWithIconProps } from '../InputWithIcon';

const InputNumber = (props: InputWithIconProps) => {
  return <Input {...props} type='number'/>;
};

export default InputNumber;
